import React from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import { AttendanceSheetStateDto } from '../../../../../api-service/clients';
import { ColorPalette } from '../../../../../components/config';

interface IAttendanceProtocolTitlezoneProps {
  courseName?: string;
  lessonBeginAt: string | Date;
  lessonEndAt: string | Date;
  attendanceSheetState?: AttendanceSheetStateDto;
}

export function getApprovalStatusText(attendanceSheetState?: AttendanceSheetStateDto) {
  switch (attendanceSheetState) {
    case AttendanceSheetStateDto.Submitted:
      return 'Godkendt';
    case AttendanceSheetStateDto.ReadyForApproval:
      return 'Klar til godkendelse';
    default:
      return 'Ikke godkendt';
  }
}

export function AttendanceProtocolTitlezone(props: IAttendanceProtocolTitlezoneProps) {
  const { courseName, lessonBeginAt, lessonEndAt, attendanceSheetState } = props;
  const lessonDate = format(new Date(lessonBeginAt), 'dd-MM-yyyy');
  const startTime = format(new Date(lessonBeginAt), 'HH:mm');
  const endTime = format(new Date(lessonEndAt), 'HH:mm');

  return (
    <Box sx={{ padding: 2, backgroundColor: ColorPalette.ScrubsGreen }}>
      <Typography sx={{ fontSize: '0.875rem' }}>{`Protokol (${getApprovalStatusText(attendanceSheetState)})`}</Typography>
      <Typography sx={{ fontWeight: 'bold', fontSize: '1.4em' }}>{`Registrér fremmøde - '${courseName ?? ''}' ${lessonDate} (${startTime} - ${endTime})`}</Typography>
    </Box>
  );
}
